import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // hoppa inte in när vi navigerar till en specifik anchor (#section)
    if (hash) return;

    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    // vänta till efter route-render för att undvika jank
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: prefersReduced ? "auto" : "smooth" });
    });
  }, [pathname, hash]);

  return null;
}
